import { useMemo, useRef } from 'react'
import { useFormState } from 'react-final-form'
import { PROPOSAL_TEMPLATE_INPUTS_FIELDS } from '../constants'
import { prepareSettingsDataFormSubmit } from '../ProposalTemplates'

const fieldsWithName = PROPOSAL_TEMPLATE_INPUTS_FIELDS.filter(
  (field: { fieldName?: string }) => field.fieldName != null
) as { fieldName: string }[]

/**
 * Shared hook for the classic proposal-template preview UI.
 *
 * Returns the current form values reduced to the named template-setting fields, plus a ref that
 * is always pointed at the latest value. The ref lets `loadProposalData` callbacks read the
 * freshest settings without re-creating the callback on every keystroke.
 */
export const useFormattedProposalSettings = () => {
  const { values: formValues } = useFormState({ subscription: { values: true } })

  const formattedSettings = useMemo(() => {
    const formatted = prepareSettingsDataFormSubmit(formValues)
    const settings: Record<string, unknown> = {}
    fieldsWithName.forEach((field) => {
      settings[field.fieldName] = formatted[field.fieldName]
    })
    return settings
  }, [formValues])

  const formattedSettingsRef = useRef(formattedSettings)
  formattedSettingsRef.current = formattedSettings

  return { formattedSettings, formattedSettingsRef }
}
